// extracted by mini-css-extract-plugin
export var orderSummary = "_rr-0";
export var showMoreLessButton = "_rr-1";